// File: src/components/registration/steps/claimsSteps/ClaimsSystemCard.jsx
import React, { useState } from "react";
import PropTypes from "prop-types";
import "./UserSystemCard.css"; // Reuse the same CSS styles

import ClaimsStep1Intro from "./claimsSteps/ClaimsStep1Intro";
import ClaimsStep2ApprovalGate from "./claimsSteps/ClaimsStep2ApprovalGate";

const ClaimsSystemCard = ({ companyStructure, claimsSystem, onChange }) => {
  const [cardStep, setCardStep] = useState(1);
  const [isCompleted, setIsCompleted] = useState(false);
  const [isHidden, setIsHidden] = useState(false);

  const finishFlow = () => {
    setIsCompleted(true);
    setTimeout(() => {
      setIsHidden(true);
    }, 2000);
  };

  if (isHidden) {
    return null;
  }

  if (isCompleted) {
    return (
      <div className="user-system-card slide-out-left">
        <div className="completion-container">
          <div className="green-check">✔</div>
          <h2 className="completion-title">Claims System Complete</h2>
        </div>
      </div>
    );
  }

  return (
    <div className="user-system-card system-card">
      {cardStep === 1 && <ClaimsStep1Intro setCardStep={setCardStep} />}
      {cardStep === 2 && (
        <ClaimsStep2ApprovalGate
          setCardStep={setCardStep}
          companyStructure={companyStructure}
          claimsSystem={claimsSystem}
          onChange={onChange}
          finishFlow={finishFlow}
        />
      )}
    </div>
  );
};

ClaimsSystemCard.propTypes = {
  companyStructure: PropTypes.object,
  claimsSystem: PropTypes.object.isRequired, // renamed
  onChange: PropTypes.func.isRequired,
};

export default ClaimsSystemCard;
